import _ from 'lodash';


export function updateItemInList(items, idToUpdate, updateFunction) {
  return _.map(items, (item) => {
    if (item.id !== idToUpdate) return item;
    return updateFunction(item);
  });
}

export function addItemToList(items, newItem, sortBy) {
  items.push(newItem);
  const sortedItems = _.sortBy(items, sortBy);
  return sortedItems;
}

export function buildTypes(prefix, defaultTypes) {
  const types = defaultTypes || ['SET', 'CLEAR'];

  return _.zipObject(types, _.map(types, type => `${prefix}/${type}`));
}

export function buildStandardReducer(types) {
  return (state = {}, action = { data: {} }) => {
    switch (action.type) {
      case types.SET:
        _.assign(state, action.data);
        break;
      case types.CLEAR:
        return {};
      default:
        return state;
    }

    return { ...state };
  };
}



// WEBPACK FOOTER //
// ./app/utils/reducer-utils.js